import React from 'react';
import { Button, Form, Header, Segment, Checkbox } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { fetchFaculties } from '../../Lookups/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class AddCourse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            englishName: null,
            name: '',
            comment: '',
            faculty: '',
            faculties: [],
            facultyList: [],

            isGlobal: false,

            nameErr: false,
            facultyErr: false,

        };

        this.addCourse = this.addCourse.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getFacultyName = this.getFacultyName.bind(this);
    }

    componentDidMount() {
        axios.all([fetchFaculties()])
            .then(axios.spread((facultiesRes) => {
                const faculties = facultiesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));

                this.setState({ faculties });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch faculties');
            });
    }

    getFacultyName(id) {
        const { faculties } = this.state;
        const selected = faculties.find(el => el.id === id);
        if (selected && selected.text) return selected.text;
        return '';
    }


    addCourse(name, englishName, globalCourse, faculty, facultyList) {
        if (!faculty || !name) {
            toast('Morate unijeti obavezna polja');
            if (!faculty) { this.setState({ facultyErr: true }); } else { this.setState({ facultyErr: false }); }
            if (!name) { this.setState({ nameErr: true }); } else { this.setState({ nameErr: false }); }
        } else {
            const mainFaculty = { id: faculty, name: this.getFacultyName(faculty) };
            const organizationalUnits = facultyList.map(el => ({ id: el, name: this.getFacultyName(el) }));
            organizationalUnits.push({ id: faculty, name: this.getFacultyName(faculty) });
            let newCourse = {};
            let language = { twoLetterCode: 'en' };
            let translations = [{ name: englishName, language }];

            if (name) newCourse = { ...newCourse, name };
            if (globalCourse) newCourse = { ...newCourse, globalCourse };
            if (mainFaculty) newCourse = { ...newCourse, mainFaculty };
            if (organizationalUnits) newCourse = { ...newCourse, organizationalUnits };
            if (englishName !== null) newCourse = { ...newCourse, translations };

            axios.post('/course/basic/', { ...newCourse })
                .then(res => {
                    toast('Uspješno ste kreirali predmet!');
                })
                .catch(err => {
                    toast('Došlo je do greške! Kreiranje predmeta nije uspjelo.');
                });
            window.history.go(-1);
        }
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <div>
                <Header as="h1">Kreiranje predmeta</Header>
                <Segment.Group raised>
                    <Segment clearing>
                        <Header as="h3">
                            Forma za kreiranje predmeta
                        </Header>
                    </Segment>
                    <Segment clearing>
                        <Form>
                            <Form.Group widths="equal">

                                <Form.Field required error={this.state.nameErr}>
                                    <label>Naziv predmeta</label>
                                    <input
                                        value={this.state.name}
                                        onChange={(e) => this.setState({ name: e.target.value })}
                                        name="name"
                                        placeholder="Unesite naziv predmeta"
                                    />
                                </Form.Field>
                                <Form.Field>
                                </Form.Field>
                            </Form.Group>

                            <Form.Group widths="equal">

                                <Form.Field>
                                    <label>Naziv predmeta na engleskom jeziku</label>
                                    <input
                                        value={this.state.englishName}
                                        onChange={(e) => this.setState({ englishName: e.target.value })}
                                        name="englishName"
                                        placeholder="Unesite naziv predmeta na engleskom jeziku"
                                    />
                                </Form.Field>
                                <Form.Field>
                                </Form.Field>
                            </Form.Group>

                            <Form.Group widths="equal">
                                <Form.Field required>
                                    <label>  Matični fakultet</label>
                                    <Form.Dropdown
                                        clearable
                                        selection
                                        placeholder="Odaberite matični fakultet"
                                        value={this.state.faculty}
                                        onChange={this.handleInputChange}
                                        name="faculty"
                                        options={this.state.faculties}
                                        search
                                        fluid
                                        error={this.state.facultyErr}
                                    />
                                </Form.Field>
                            </Form.Group>

                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Fakultet(i)</label>
                                    <Form.Dropdown
                                        clearable
                                        multiple
                                        selection
                                        placeholder="Odaberite jedan ili više fakulteta"
                                        value={this.state.facultyList}
                                        onChange={this.handleInputChange}
                                        name="facultyList"
                                        options={this.state.faculties.filter(el => el.id !== this.state.faculty)}
                                        search
                                        fluid
                                    />
                                </Form.Field>
                            </Form.Group>

                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>  Je li predmet globalni?</label>
                                    <Checkbox
                                        label=""
                                        value={this.state.isGlobal}
                                        onChange={(e) => this.setState({ isGlobal: !this.state.isGlobal })}
                                    />
                                </Form.Field>
                            </Form.Group>

                            <Button
                                color="blue"
                                floated='right'
                                onClick={
                                    () => {
                                        this.addCourse(
                                            this.state.name,
                                            this.state.englishName,
                                            this.state.isGlobal,
                                            this.state.faculty,
                                            this.state.facultyList
                                        );
                                    }
                                }
                            >
                                Kreiraj predmet
                            </Button>
                            <Button color="blue" basic="true" floated='right' onClick={() => window.history.go(-1)}>Odustani</Button>
                        </Form>
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group >
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateCourse/AddCourse.js